import * as React from 'react'

import { SidebarWrapper, ColumnHeader, SidebarBody } from './SidebarStyles'

const showPinSelector = false

const Pin = require('./my_project_pin.svg')
const Caret = require('./my_project_caret_down.svg')

const Sidebar = props => (
  <SidebarWrapper altBg={props.altBg}>
    {props.title && (
      <h3 className="sidebar-title">
        {props.title}

        {showPinSelector && (
          <div style={{ display: 'inline' }}>
            <img src={Caret} alt="" title="not yet available" />
            <img src={Pin} alt="" title="not yet available" />
          </div>
        )}
      </h3>
    )}
    {props.toolbar && <ColumnHeader>{props.toolbar}</ColumnHeader>}
    <div className="sidebar-content">{props.children}</div>
  </SidebarWrapper>
)

export { SidebarBody, ColumnHeader }

export default Sidebar



// WEBPACK FOOTER //
// ./src/Components/Shared/Sidebar/index.tsx